import Vue from 'vue'
import Amplify, * as AmplifyModules from 'aws-amplify';
import { AmplifyPlugin } from 'aws-amplify-vue';
import AWS_PROPERTIES from '../aws-exports';

Amplify.configure(AWS_PROPERTIES);
Vue.use(AmplifyPlugin, AmplifyModules);

export default {}
